<template>
  <div>
    <div v-if="!busy">
      <div
        :class="['dropZone', dragging ? 'dropZone-over' : '']"
        @dragenter="dragging = true"
        @dragover="dragging = true"
        @dragleave="dragging = false"
      >
        <div class="dropZone-info" @drag="onChange">
          <span class="fa fa-cloud-upload dropZone-title"></span>
          <span class="dropZone-title">
            <v-icon big class="dropZone-title dropZone-title"
              >mdi-cloud-upload</v-icon
            >
            {{label}}
          </span>
        </div>
        <input type="file" ref="file" :accept="accept" :multiple="multiple" @change="onChange" />
      </div>
    </div>
    <div v-else class="dropZone-uploaded">
      <div class="dropZone-uploaded-info">
        <span class="dropZone-title">Uploading...</span>
      </div>
    </div>
  </div>
</template>


<script>
// import { defineComponent } from '@vue/composition-api'

export default {
  props: {
    value: { type: [File, FileList, Array] },
    label: { type: String, default: 'Drop image file or click to upload' },
    multiple: {type: Boolean, default: false},
    accept: {type: String, default:"*"}
  },
  data: () => ({
    busy: false,
    dragging: false,
  }),
  methods: {
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files);
    },
    toBase64: file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => { file.base64 = reader.result; resolve(file) };
      reader.onerror = error => reject(error);
    }),
    createFile(files) {

      this.busy = true

      const arr = [...files]

      var promises = [];
      arr.map( file => {
        promises.push(this.toBase64(file))
      })

      Promise.all(promises).then( (all) => {
        this.dragging = false
        let file = this.multiple ? all : all[0];
        this.$emit("input", file);
      })
      
    },
    setBusy(v) {
      this.busy = v
    }
  },
  computed: {
  },
};
</script>


<style scoped>
.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dotted #a8a8a8;
}

.dropZone:hover {
  border: 2px dotted #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975a0;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
  opacity: 0.7;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 80%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>


